<template>
    <div class="dashboard">
      <p>{{ username }}님 환영합니다.</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        username: ''
      }
    },
    mounted() {
      this.username = localStorage.getItem('username') || 'Guest';
    }
  }
  </script>
  
  <style scoped>
  .dashboard {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f3f1;
  }
  
  h1 {
    font-size: 2em;
    color: #8B7765;
  }
  </style>